<template>
  <section class="tripadvisor-reviews">
    <ul
      class="tripadvisor-reviews-list"
      aria-labelledby="tripadvisor-reviews-heading"
      tabindex="0"
    >
      <li
        v-for="review in reviews"
        :key="review.id"
        class="tripadvisor-reviews__item"
        data-test-id="review"
      >
        <div class="tripadvisor-reviews__meta">
          <ERating
            :value="review.rating"
            :show-value="false"
            variant="tripadvisor"
          />
          <time
            :datetime="review.datePublished"
            class="tripadvisor-reviews__date"
            data-test-id="review-date"
          >
            {{ formatDate(review.datePublished) }}
          </time>
        </div>
        <p class="tripadvisor-reviews__text">
          <span :lang="review.language" data-test-id="review-text">
            &ldquo;{{ formatText(review.text) }}&rdquo;
          </span>
          <ELink
            :href="review.url"
            color="result"
            target="_blank"
            rel="noopener"
            data-test-id="more-link"
            @click="trackClick('review_more_link')"
          >
            {{ $t('web.entities.readMore') }}
          </ELink>
        </p>
      </li>
    </ul>
    <ELink
      :href="sourceUrl"
      color="result"
      target="_blank"
      rel="noopener"
      data-test-id="view-all-link"
      @click="trackClick('all_reviews_link')"
    >
      {{ $t('web.entities.tripadvisor.reviews.viewall') }}
    </ELink>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { trackClick, TYPE_ENTITY } from '~~/search/common/js/client/analytics/rich-content';
import { truncateText } from '~~/common/js/universal/utils';
import { isValidDate } from '~~/common/js/universal/validators';
import ELink from '~~/common/vue/components/link';
import ERating from '~~/common/vue/components/rating';

const MAX_TEXT_LENGTH = 120;
const dateOptions = { month: 'short', year: 'numeric' };

export const TRACK_ID = 'tripadvisor';

export default {
  name: 'EReviews',
  components: {
    ELink,
    ERating,
  },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
    sourceUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('global', ['locale']),
  },
  methods: {
    formatDate(serialised) {
      const date = new Date(serialised);
      if (!isValidDate(date)) {
        return '';
      }

      return date.toLocaleDateString(this.locale, dateOptions);
    },
    formatText(original) {
      return truncateText(original, MAX_TEXT_LENGTH);
    },
    trackClick(target) {
      trackClick({
        type: TYPE_ENTITY,
        name: TRACK_ID,
        target,
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
.tripadvisor-reviews {
  padding-bottom: $space-1s;
}

.tripadvisor-reviews-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.tripadvisor-reviews__meta {
  display: flex;
  align-items: center;
}

.tripadvisor-reviews__date {
  color: var(--color-text-secondary);
  margin-left: $space-1s;
  white-space: nowrap;
}

.tripadvisor-reviews__text {
  margin: $space-2s 0 $space-m;
}
</style>
